import CopyValueToClipboard from "views/logic/valueactions/CopyValueToClipboard";
import SelectExtractorType from "views/logic/valueactions/SelectExtractorType";
export const CopyToClipBoardValueActionPlugin = {
  type: "copy-value-to-clipboard",
  title: "Copy value to clipboard",
  handler: CopyValueToClipboard,
  isEnabled: CopyValueToClipboard.isEnabled,
  resetFocus: false
};
export const CreateExtractorValueActionPlugin = {
  type: "create-extractor",
  title: "Create extractor",
  isEnabled: ({ type, contexts }) => !!contexts.message && !type.isDecorated() && !!contexts.isLocalNode,
  component: SelectExtractorType,
  resetFocus: false
};
